"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevOutline = exports.LineStyle = exports.FillStyle = void 0;
class FillStyle {
    constructor(color = 0xFFFFFF, alpha = 0.5) {
        this.color = color;
        this.alpha = alpha;
    }
}
exports.FillStyle = FillStyle;
class LineStyle extends FillStyle {
    constructor(lineWidth = 1, color = 0xFFFFFF, alpha = 0.5) {
        super(color, alpha);
        this.lineWidth = lineWidth;
    }
}
exports.LineStyle = LineStyle;
/**
 * Adds a graphics rectangle on a display object.
 * It draws the rectangle when added to display object or when update() is called.
 *
 * So if the parent object changes size, update needs to be called.
 *
 *
 * Usage:
 *
 *  myDisplayObject.addChild(new DevOutline());
 *
 * Created: 2017-06-14
 * @author jonas
 */
class DevOutline extends PIXI.Container {
    /**
     * Constructor
     * @param {number} lineWidth
     * @param {number} color
     * @param {number} alpha
     * @param {number} fillColor
     * @param {number} fillAlpha
     */
    constructor(lineWidth = 1, color = 0xFFFFFF, alpha = 0.5, fillColor = 0xFFFFFF, fillAlpha = 0) {
        super();
        this._lineStyle = new LineStyle(lineWidth, color, alpha);
        this._fillStyle = new FillStyle(fillColor, fillAlpha);
        this.on("added", (container) => this.onAdded(container));
        this.init();
        console.warn("DevOutline is used, remove before release!");
    }
    init() {
        this._outline = new PIXI.Graphics();
        this.addChild(this._outline);
    }
    onAdded(container) {
        this._target = container;
        this.update();
    }
    setCustomRect(rect) {
        this._customRect = rect;
        this.update();
        return this;
    }
    clearCutomRect() {
        this._customRect = null;
        this.update();
        return this;
    }
    update() {
        if (!this._target) {
            return;
        }
        let local = this._target.getLocalBounds();
        if (this._customRect) {
            local = this._customRect;
        }
        this._outline.clear();
        this._outline.lineStyle(this._lineStyle.lineWidth, this._lineStyle.color, this._lineStyle.alpha);
        if (this._fillStyle.alpha > 0) {
            this._outline.beginFill(this._fillStyle.color, this._fillStyle.alpha);
        }
        this._outline.drawRect(local.x, local.y, local.width, local.height);
        this._outline.endFill();
    }
}
exports.DevOutline = DevOutline;
//# sourceMappingURL=DevOutline.js.map